// src/components/AdBanner.js
import React, { useState, useEffect } from 'react';


const AdBanner = () => {
  const [showAd, setShowAd] = useState(true);
  const [adType, setAdType] = useState('premium');

  // Simulate different ad types
  useEffect(() => {
    const adTypes = ['premium', 'study-tools', 'ai-features', 'community'];
    const randomAd = adTypes[Math.floor(Math.random() * adTypes.length)];
    setAdType(randomAd);
  }, []);

  const ads = {
    'premium': {
      title: "🚀 Upgrade to Premium",
      description: "Unlock unlimited flashcards, AI features, and offline access",
      cta: "Try 7 Days Free",
      link: "/upgrade",
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    'study-tools': {
      title: "📊 Advanced Analytics",
      description: "Track your progress with detailed insights and performance metrics",
      cta: "Learn More",
      link: "/features/analytics",
      color: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    'ai-features': {
      title: "🤖 AI-Powered Learning",
      description: "Let AI generate flashcards from your notes automatically",
      cta: "Try AI Features",
      link: "/ai-features",
      color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    },
    'community': {
      title: "👥 Join Study Groups",
      description: "Collaborate with other learners and share flashcard decks",
      cta: "Explore Community",
      link: "/community",
      color: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
    }
  };

  const currentAd = ads[adType];

  if (!showAd) return null;

  const handleClose = () => {
    setShowAd(false);
    // Store preference in localStorage
    localStorage.setItem('hideAdsUntil', Date.now() + 24 * 60 * 60 * 1000); // Hide for 24 hours
  };

  return (
    <div className="ad-banner" style={{ background: currentAd.color }}>
      <div className="ad-content">
        <div className="ad-text">
          <h4 className="ad-title">{currentAd.title}</h4>
          <p className="ad-description">{currentAd.description}</p>
        </div>
        <div className="ad-actions">
          <a href={currentAd.link} className="ad-button">
            {currentAd.cta}
          </a>
          <button onClick={handleClose} className="ad-close">
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdBanner;